import React from 'react';
import { cardColors } from './cardColors';

export default function KenoBoard({ activeCard, cardSelections, onToggleNumber, showAllCards, drawnNumbers, bets = {} }) {
    function renderCell(num) {
      const display = getNumberDisplay(num);
      let style = {};
      if (showAllCards && display === '*') {
        if (drawnNumbers?.includes(num)) {
          style.border = '4px solid red';
        } else {
          style.border = '4px solid #0033cc';
        }
      }
      return (
        <div
          key={num}
          className={`cell ${isNumberDisplayed(num) ? 'selected' : 'empty'} ${drawnNumbers?.includes(num) ? 'drawn' : ''} ${display === '*' ? 'asterisk' : ''}`}
          style={style}
          onClick={() => onToggleNumber(num)}
        >
          <span className="cell-inner">{display}</span>
        </div>
      );
    }
    // Display asterisk for multi-card, card letter for single card, number otherwise
    const getNumberDisplay = (num) => {
      if (showAllCards) {
        // Show asterisk if selected on multiple cards with bets
        const cardsWithBet = Object.keys(cardSelections).filter(card => (bets[card] || 0) > 0 && cardSelections[card].includes(num));
        if (cardsWithBet.length > 1) return '*';
        if (cardsWithBet.length === 1) return cardsWithBet[0];
        return num;
      } else if (activeCard) {
        // Single card mode: show card letter if selected, else number
        const cardHasBet = (bets[activeCard] || 0) > 0;
        if (cardHasBet && cardSelections[activeCard]?.includes(num)) return activeCard;
        return num;
      }
      return num;
    };
  const numbers = Array.from({ length: 80 }, (_, i) => i + 1);

  const isNumberDisplayed = (num) => {
    if (!showAllCards && activeCard) {
      const cardHasBet = (bets[activeCard] || 0) > 0;
      return cardHasBet && cardSelections[activeCard]?.includes(num);
    } else if (!showAllCards && !activeCard) {
      return false;
    } else {
      // In show-all mode, highlight cells that are selected on any card with a bet
      return Object.keys(cardSelections).some(card => (bets[card] || 0) > 0 && cardSelections[card].includes(num));
    }
  };

    function getBoardBackgroundColor(activeCard, showAllCards) {
      if (!showAllCards && activeCard && cardColors[activeCard]) {
        return cardColors[activeCard];
      }
      return '#f8f9fa';
    }
  
    const boardColor = getBoardBackgroundColor(activeCard, showAllCards);
    return (
      <div className="keno-board-outer-frame">
        <div
          className="keno-board"
          style={{
            '--keno-board-border': boardColor
          }}
        >
          {numbers.map((num, idx) => {
            // Insert black gap container before the 5th row (before cell 41, idx 40)
            if (idx === 40) {
              return [
                <div
                  key="gap-container"
                  className="keno-gap-container"
                  style={{ gridColumn: '1 / 11', gridRow: 5 }}
                />,
                renderCell(num)
              ];
            }
            return renderCell(num);
          })}
        </div>
      </div>
    );
};
/* comment added to trigger edit detection */

